import { render, staticRenderFns } from "./DefStandardModal.vue?vue&type=template&id=690bc39c&"
import script from "./DefStandardModal.vue?vue&type=script&lang=js&"
export * from "./DefStandardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports